<rid-dictation-visual
  class="h-dvh"
  [previewMs]="2000"
  [words]="[
    {
      word: 'tijger',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
    },
    {
      word: 'leeuw',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
    },
    {
      word: 'zebra',
      audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
    },
  ]"
  (finished)="$router.navigate(['/mechanics/dictation'])"
/>
